import React, { lazy } from "react";

const StringerPage = lazy(() => import("./StringerPage"));

export { StringerPage };
